import { Flex, Text, Spinner } from "@chakra-ui/react";
import React from "react";

export function LoadingIndicator({ content }: { content: string }) {
  return (
    <Flex justifyContent="center" alignItems="center" py={4} gap={4}>
      <Text fontSize="lg" fontWeight="bold">
        {content}
      </Text>
      <Spinner />
    </Flex>
  );
}
